import React, { useEffect, useRef } from 'react';
import ScoreCard from './components/ScoreCard/index';
import ScoreGraph from './components/ScoreGraph';
import { makeStyles } from '@material-ui/core/styles';
import './styles.scss';
import Button from '@material-ui/core/Button';
import { get, isEmpty, isNull } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTestResult } from '../../../../actions/performanceAnalysisActions';
import { useParams } from 'react-router-dom';
import PopUpModal from '../../../../components/PopUpModal';
import TestSolution from '../TestSolution';
import ORSSheet from '../ORSSheet';
import InfoIcon from '../../../../assets/info-with-circle.svg';
import ScoreTable from './components/ScoreTable';
import EPICard from './components/EPICard';
import { Tab, Grid } from '@material-ui/core';
import TabContext from '@material-ui/lab/TabContext';
import TabPanel from '@material-ui/lab/TabPanel';
import AnswerKeyResponses from '../AnsweKeyResponses';
import PageHeading from '../../../../components/PageHeading';
import NoData from '../../../../components/NoData';
import { TabList, Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%',
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '50%',
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%',
    },
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
}));

export default function TestPerformanceScores() {
  const classes = useStyles();
  const childRef = useRef();
  const childRefORS = useRef();
  const childRefAnswerKey = useRef();
  const childRefEPI = useRef();
  const [value, setValue] = React.useState('1');
  const [isFetching, setIsFetching] = React.useState(true);
  let { testID } = useParams();
  //Redux
  const dispatch = useDispatch();
  const jwtToken = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', '')
  );
  const ResultData = useSelector((state) =>
    get(state, 'performanceAnalysisReducer.testResult', {})
  );
  const errorMessage = useSelector((state) =>
    get(state, 'performanceAnalysisReducer.errorMessage', {})
  );
  useEffect(() => {
    setIsFetching(true);
    fetchTestResult(jwtToken, testID, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const listRank =
    ResultData && ResultData.listRank && ResultData.listRank.length > 0
      ? ResultData.listRank
      : [];
  const listSubjectRank =
    ResultData &&
    ResultData.listSubjectRank &&
    ResultData.listSubjectRank.length > 0
      ? ResultData.listSubjectRank
      : [];
  const graphData =
    ResultData &&
    ResultData.listContainer &&
    ResultData.listContainer.length > 0
      ? ResultData.listContainer
      : [];

  let checkCourseType = () => {
    if (ResultData && Object.keys(ResultData).length > 0) {
      if (ResultData.listPNCFScore) {
        return 'listPNCFScore';
      } else if (ResultData.listMedicalScore) {
        return 'listMedicalScore';
      } else if (ResultData.listKCETScore) {
        return 'listKCETScore';
      }
    }
    return 'listJEEScore';
  };

  const checkPaper2Exist = () => {
    return (
      ResultData &&
      ResultData.Wing === '2' &&
      ResultData.TestTypeID === 1 &&
      ResultData.TestTypeSubject === '1'
    );
  };

  const header = <div>Exam Solution </div>;
  const body = testID && <TestSolution testID={testID} />;
  const headerORS = <div>ORS Sheet </div>;
  const bodyORS = testID && (
    <ORSSheet testID={testID} paper2Exist={checkPaper2Exist()} />
  );
  const handleSolution = () => {
    childRef.current.handleClickOpen();
  };
  const handleORS = () => {
    childRefORS.current.handleClickOpen();
  };
  const handleAnswerKey = () => {
    childRefAnswerKey.current.handleClickOpen();
  };
  const headerAnswerKey = <div>Answer Key </div>;

  const bodyAnswerKey = testID && <AnswerKeyResponses testID={testID} />;

  const courseType = checkCourseType();

  const courseScores =
    ResultData &&
    Object.keys(ResultData).length > 0 &&
    ResultData[courseType] &&
    ResultData[courseType].length > 0
      ? ResultData[courseType]
      : [];

  const containsEPI = () => {
    if (
      ResultData &&
      Object.keys(ResultData).length > 0 &&
      ResultData.listJEEScore
    ) {
      return ResultData.listJEEScore.some((item) =>
        item.Criteria.includes('EPI')
      );
    }
  };
  const handleEpiData = () => {
    childRefEPI.current.handleClickOpen();
  };

  const epiHeader = <div>Info </div>;
  const epiBody = <EPICard containsEPI={containsEPI()} />;

  return !isEmpty(ResultData) || isFetching ? (
    <React.Fragment>
      <PageHeading titlePrimary="Test Performance" titleSecondary="Analysis" />
      <Grid container>
        <Grid item md>
          {isFetching ? (
            <Skeleton width="30%" />
          ) : (
            <h2>{!isEmpty(ResultData.Test) && ResultData.Test}</h2>
          )}
        </Grid>
        {!isFetching && (
          <Grid item md="auto" className="test-per-subheader-buttons">
            {ResultData.SolutionStatus && (
              <Button
                className="header-buttons"
                variant="contained"
                color="secondary"
                onClick={handleSolution}
              >
                Question Paper and Solution
              </Button>
            )}
            {ResultData.ORSStatus && (
              <Button
                className="header-buttons"
                variant="contained"
                color="secondary"
                onClick={handleORS}
              >
                Exam ORS Sheet
              </Button>
            )}
            {ResultData.AKStatus && (
              <Button
                className="header-buttons"
                variant="contained"
                color="secondary"
                onClick={handleAnswerKey}
              >
                Compare Exam with Answer Key
              </Button>
            )}
          </Grid>
        )}
      </Grid>
      {/* Data for Paper 1 + Paper 2 */}
      {(isFetching ||
        (ResultData &&
          Object.keys(ResultData).length > 0 &&
          ResultData[checkCourseType()] &&
          ResultData[checkCourseType()].length > 0)) && (
        <div className="score-card mt-30">
          <ScoreCard
            listRank={isFetching ? [] : listRank}
            listSubjectRank={isFetching ? [] : listSubjectRank}
            courseScores={isFetching ? [] : courseScores}
            paper2={
              isFetching
                ? true
                : !isEmpty(ResultData.listJEEScorePaper2) ||
                  !isNull(ResultData.listJEEScorePaper2)
            }
            listJEEScore={
              !isEmpty(ResultData) && !isEmpty(ResultData.listJEEScore)
                ? ResultData.listJEEScore
                : []
            }
            isFetching={isFetching}
          />
        </div>
      )}
      <div className="score-card mt-40">
        <div className="heading flex align-center mb-5">
          {isFetching ? <Skeleton width="20%" /> : <h3>Relative Comparison</h3>}
          <span className="sub-head ml-5">
            {isFetching ? (
              <Skeleton width="30%" />
            ) : !isEmpty(ResultData) &&
              (!isEmpty(ResultData.listJEEScorePaper2) ||
                !isNull(ResultData.listJEEScorePaper2)) ? (
              '(Paper 1 + Paper 2)'
            ) : (
              ''
            )}
          </span>
        </div>
        <p className="mb-20 sub-text">
          {isFetching ? (
            <Skeleton width="50%" />
          ) : (
            'Your Score vs Average Score in Percentage'
          )}
        </p>
        <ScoreGraph
          graphData={isFetching ? [] : graphData}
          isFetching={isFetching}
        />
      </div>

      <div>
        {!isFetching &&
          ResultData &&
          ResultData.listJEEScorePaper1 &&
          ResultData.listJEEScorePaper1.length > 0 &&
          ResultData.listJEEScorePaper2 &&
          ResultData.listJEEScorePaper2.length > 0 && (
            <div className="tab-design mt-30">
              <TabContext value={value}>
                <TabList
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  className="line-tab"
                >
                  <Tab label="Paper 1" value="1" />
                  <Tab label="Paper 2" value="2" />
                </TabList>
                <TabPanel value="1">
                  {/* Data for Paper 1 */}
                  {ResultData &&
                    ResultData.listJEEScorePaper1 &&
                    ResultData.listJEEScorePaper1.length > 0 && (
                      <div className="section">
                        <div className="heading flex align-center">
                          <h3>Score Card</h3>
                          <span className="sub-head ml-5">(Paper 1)</span>
                          <span className="emi-icon ml-auto cursor">
                            <img src={InfoIcon} onClick={handleEpiData} />
                          </span>
                        </div>
                        <ScoreTable
                          courseScores={ResultData.listJEEScorePaper1}
                          paper2={
                            !isEmpty(ResultData.listJEEScorePaper2) ||
                            !isNull(ResultData.listJEEScorePaper2)
                          }
                        />
                      </div>
                    )}
                  {ResultData &&
                    ResultData.listContainer1 &&
                    ResultData.listContainer1.length > 0 && (
                      <div className="score-card mt-40">
                        <div className="heading flex align-center mb-5">
                          <h3>Relative Comparison</h3>
                          <span className="sub-head ml-5">(Paper 1)</span>
                        </div>
                        <p className="mb-20 sub-text">
                          Your Score vs Average Score in Percentage
                        </p>
                        <ScoreGraph
                          graphData={!isFetching && ResultData.listContainer1}
                          paper2={
                            (!isFetching &&
                              !isEmpty(ResultData.listJEEScorePaper2)) ||
                            !isNull(ResultData.listJEEScorePaper2)
                          }
                        />
                      </div>
                    )}
                </TabPanel>
                <TabPanel value="2">
                  {/* Data for Paper 2 */}
                  {ResultData &&
                    ResultData.listJEEScorePaper2 &&
                    ResultData.listJEEScorePaper2.length > 0 && (
                      <div className="section">
                        <div className="heading flex align-center">
                          <h3>Score Card</h3>
                          <span className="sub-head ml-5">(Paper 2)</span>
                          <span className="emi-icon ml-auto cursor">
                            <img src={InfoIcon} onClick={handleEpiData} />
                          </span>
                        </div>
                        <ScoreTable
                          courseScores={ResultData.listJEEScorePaper2}
                          paper2={
                            !isEmpty(ResultData.listJEEScorePaper2) ||
                            !isNull(ResultData.listJEEScorePaper2)
                          }
                        />
                      </div>
                    )}
                  {ResultData &&
                    ResultData.listContainer2 &&
                    ResultData.listContainer2.length > 0 && (
                      <div className="section mt-30">
                        <div className="heading flex align-center mb-5">
                          <h3>Relative Comparison</h3>
                          <span className="sub-head ml-5">(Paper 2)</span>
                        </div>
                        <p className="mb-20 sub-text">
                          Your Score vs Average Score in Percentage
                        </p>
                        <ScoreGraph
                          graphData={ResultData.listContainer2}
                          paper2={
                            !isEmpty(ResultData.listJEEScorePaper2) ||
                            !isNull(ResultData.listJEEScorePaper2)
                          }
                        />
                      </div>
                    )}
                </TabPanel>
              </TabContext>
            </div>
          )}
      </div>
      <PopUpModal
        ref={childRefORS}
        header={headerORS}
        body={bodyORS}
        fullScreen={true}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
      />
      <PopUpModal
        ref={childRefAnswerKey}
        header={headerAnswerKey}
        body={bodyAnswerKey}
        fullScreen={true}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
      />

      <PopUpModal
        ref={childRef}
        header={header}
        body={body}
        fullScreen={true}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        className="question-popup"
      />
      <PopUpModal
        ref={childRefEPI}
        header={epiHeader}
        body={epiBody}
        width={classes.dialogCustomizedWidth}
      />
    </React.Fragment>
  ) : (
    <React.Fragment>
      <PageHeading titlePrimary="Test Performance" titleSecondary="Analysis" />
      <NoData
        message={
          !isEmpty(errorMessage)
            ? errorMessage
            : 'As of now, no Data is available for Analysis.'
        }
      />
    </React.Fragment>
  );
}
